export default __webpack_public_path__ + "static/media/1.330faff6.png";